let _Vue = null;

export default {
    install(Vue) {
        
        if (Vue === _Vue) {
            return;
        }
        let _vue = _Vue = Vue;

        const _originalEmit = _vue.prototype.$emit;
        _vue.prototype.$emit = function(eventName, ...args) {

            return _originalEmit.apply(this, [eventName ? Cgl.Str.HumpToHLine(eventName) : eventName].concat(args || []));

        };

        const _originalOn = _vue.prototype.$on;
        _vue.prototype.$on = function(eventName, fn) {

            return _originalOn.apply(this, [eventName ? Cgl.Str.HumpToHLine(eventName) : eventName, fn]);

        };

        const _originalOff = _vue.prototype.$off;
        _vue.prototype.$off = function(eventName, fn) {
            return _originalOff.apply(this, [eventName ? Cgl.Str.HumpToHLine(eventName) : eventName, fn]);
        }
    }
};